export var tryGetBoolean = function tryGetBoolean(value) {
  return typeof value === 'boolean' ? value : undefined;
};